import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-back",
  "use": "icon-arrow-back-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-arrow-back\"><path d=\"m8 15.5 1.057-1.057L3.373 8.75H15.5v-1.5H3.373l5.684-5.692L8 .5.5 8 8 15.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol